define('modules/editor/views/property_boxes/form_geometry',['require','exports','module','./base','ldsh!../../templates/property_boxes/form_geometry'],function(require, exports, module) {
  "use strict";

  var BasePropertyBox = require("./base");

  module.exports = BasePropertyBox.extend({
    template: require("ldsh!../../templates/property_boxes/form_geometry")
  });

});

